import React from 'react';
import classNames from 'classnames';
import { invoiceDate } from '@adjust/dashboard-core/lib/format/dateTime';
import { InvoiceType } from '@api/types';
import { getLocalizedStatus } from '@react/Pages/AccountSettingsPage/InvoicesPage/InvoicesPage.utils';

interface InvoiceProps {
  invoiceType: InvoiceType;
  downloadUrl: string;
  billingPeriodStart: string;
  billingPeriodEnd: string;
  totalPriceNet: string;
  status: string;
}

const Invoice: React.FC<InvoiceProps> = ({
  status,
  downloadUrl,
  billingPeriodStart,
  billingPeriodEnd,
  totalPriceNet,
  invoiceType,
}) => {
  const invoiceStatusClass = classNames(
    'your-data-invoice__status-label',
    `your-data-invoice__status-label--${status}`,
  );

  const isCreditNote = invoiceType === InvoiceType.CreditNote;
  const formattedTotalPriceNet = isCreditNote ? `+${totalPriceNet}` : totalPriceNet;

  return (
    <a className={classNames('your-data-invoice', status)} target="_blank" rel="noopener noreferrer" href={downloadUrl}>
      <div className="your-data-invoice__date">
        {invoiceDate(billingPeriodStart)}
        {' - '}
        {invoiceDate(billingPeriodEnd)}
      </div>
      <div className={classNames('your-data-invoice__price', { 'your-data-invoice__price--highlight': isCreditNote })}>
        {formattedTotalPriceNet}
      </div>
      <div className="your-data-invoice__status">
        <div className={invoiceStatusClass}>{getLocalizedStatus(status, isCreditNote)}</div>
      </div>
      <div className="your-data-invoice__icon">
        <i className="icon-download" />
      </div>
    </a>
  );
};

export default Invoice;
